<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Saldos pendientes por cliente. 
                            Muestra facturas sin pagar y pagos no aplicados. 
                            Úsalo para identificar deudas, aplicar pagos
                            y priorizar la gestión de cobranza.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Partidas Abiertas
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Monitorea y procesa la información actual de <b>partidas abiertas</b> dentro de AVE.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Stock al Momento</div> -->
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <div style="display:inline-flex">
                        <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
                            <mat-icon>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                                    viewBox="0,0,256,256">
                                    <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1"
                                        stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10"
                                        stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none"
                                        font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                                        <g transform="scale(5.12,5.12)">
                                            <path
                                                d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </mat-icon>
                        </button>
                        <mat-menu #importMenu="matMenu">
                            <input #my_file style="display: none" type="file" (change)="handleFileInput($event)"
                                accept=".xlsx" #hiddenfileinput>
                            <button mat-menu-item (click)="setImportType('L'); hiddenfileinput.click()"
                                matTooltip="Importar Letras en Bancos">
                                Letras en Bancos
                            </button>
                            <button mat-menu-item (click)="setImportType('F');hiddenfileinput.click()"
                                matTooltip="Importar Facturas Negociables">
                                Facturas Negociables
                            </button>
                        </mat-menu>
                        <button mat-raised-button style="margin-right: 8px;" type="button" *ngIf="aux_file"
                            [disabled]="this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                            color="primary" (click)="onMessageConfirm()">
                            Importar archivo
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            (matSortChange)="changeSort($event)">

                            <ng-container matColumnDef="businessPartner">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Socio de <br>
                                    Negocio</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <div *ngIf="getCode(element?.businessPartner) as code">
                                            <b class="f-10">{{ code }}</b>
                                        </div>
                                        <span class="font-descrip"> {{element?.businessPartner?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="document">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Nro. Doc.</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.documentType}} - {{element.document}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="codeReason">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Tipo</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.codeReason}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="creationDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Fecha Creación
                                </th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.creationDate | FormatDateHour: false }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="expirationDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Fecha
                                    Vencimiento</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.expirationDate | FormatDateHour: false }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="availableDays">
                                <th mat-header-cell *matHeaderCellDef class="table-title text-right"
                                    arrowPosition="before">Días Vencidos</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{ getExpiredDays(element?.expirationDate) }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="paymentConditionShort">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Condición <br>
                                    de Pago</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <div *ngIf="getCode(element?.paymentConditionShort) as code">
                                            <b class="f-10">{{ code }}</b>
                                        </div>
                                        {{element?.paymentConditionShort?.name}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="additionalOC">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Referencia
                                </th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element.reference && element?.additionalOC ? element.reference + ' - ' +
                                        element?.additionalOC : (element.reference || element?.additionalOC)}} </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="totalAmount">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title text-right"
                                    arrowPosition="before">Total {{ 'code' | companyCurrency: true }}</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{element.totalAmount | number: '1.2-2'}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="balance">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title text-right"
                                    arrowPosition="before">Saldo {{ 'code' | companyCurrency: true }}</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{element.balance | number: '1.2-2'}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="bank">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Banco</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.bank}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="paymentCodeBank">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Cód. Único
                                </th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.paymentCodeBank}}
                                    </div>
                                </td>
                            </ng-container>


                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"
                                [ngClass]="{'expired-row': getExpiredDays(row?.expirationDate) > 0}"></tr>
                        </table>
                    </div>
                    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                        sentimos, no hay registros para mostrar.
                    </div>
                </div>

                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">

        <app-filter-section title="Rango de fechas" [expanded]="true">
            <app-dates-filters [form]="form" [showDateCreationRange]="true"
                [showExpirationDateRange]="true"></app-dates-filters>
        </app-filter-section>

        <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
            <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true" [loadData]="loadConfigData"></app-configuration-filters>
        </app-filter-section>


        <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
            <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
        </app-filter-section>

        <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
            <app-business-partners-filters [form]="form" [businessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
        </app-filter-section>

        <app-filter-section title="Finanzas" [expanded]="false" (onExpanded)="onFinanceExpanded()">
            <app-finance-filters [form]="form" [bankList]="bankList"
                [paymentConditionList]="paymentConditionList"></app-finance-filters>
        </app-filter-section>
    </app-filter>
</mat-sidenav-container>